import { Box, Text, VStack } from '@chakra-ui/react';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface SuspensionsCancellationsCardProps {
  data?: any;
}

const SuspensionsCancellationsCard = ({
  data,
}: SuspensionsCancellationsCardProps) => {
  const colors = useBinderCardColors();

  return (
    <Box>
      {/* Status Display */}
      <Box
        borderRadius="md"
        borderWidth="1px"
        borderColor={colors.borderColor}
        bg={colors.bgColor}
        _dark={{
          bg: colors.bgColor,
          borderColor: colors.borderColor,
        }}
        overflow="hidden"
      >
        {/* Remarks Section */}
        {data.remarks ? (
          <Box p={4}>
            <Text
              fontSize="xs"
              color={colors.labelColor}
              mb={2}
              fontWeight="semibold"
            >
              Remarks:
            </Text>
            <VStack align="start" spacing={2}>
              <Text fontSize="sm" color={colors.textColor}>
                {data.remarks}
              </Text>
            </VStack>
          </Box>
        ) : (
          <Box p={4}>
            <Text fontSize="sm" color={colors.textColor}>
              No remarks available.
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SuspensionsCancellationsCard;
